import {IFilterCategoryDefinitionFactory} from "./filter-category-definition-factory.interface";
import {CategoryDefinitionId, IFilterCategoryDefinition} from "./filter-category-definition.interface";
import {VolatilityFiltersCategoryDefinition} from "./volatility.filters-category-definition";
import {GameFeaturesFiltersCategoryDefinition} from "./game-features.filters-category-definition";
import {HasJackpotFiltersCategoryDefinition} from "./has-jackpot.filters-category-definition";
import {GameVendorFiltersCategoryDefinition} from "./game-vendor.filters-category-definition";
import {GameGroupFiltersCategoryDefinition} from "./game-group.filters-category-definition";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {JackpotTypesFiltersCategoryDefinition} from "./jackpot-types.filters-category-definition";
import {GameThemeFiltersCategoryDefinition} from "./game-theme.filters-category-definition";

export class FilterCategoryDefinitionFactory implements IFilterCategoryDefinitionFactory {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    createCategoryDefinition(categoryDefinitionId: CategoryDefinitionId): IFilterCategoryDefinition | null {
        switch (categoryDefinitionId) {
            case "volatility": return new VolatilityFiltersCategoryDefinition(this.services);
            case "features": return new GameFeaturesFiltersCategoryDefinition(this.services);
            case "hasJackpot" : return new HasJackpotFiltersCategoryDefinition(this.services);
            case "themes" : return new GameThemeFiltersCategoryDefinition(this.services);
            case "vendors" : return new GameVendorFiltersCategoryDefinition(this.services);
            case "gameGroups" : return new GameGroupFiltersCategoryDefinition(this.services);
            case "jackpotTypes": return new JackpotTypesFiltersCategoryDefinition(this.services);

            default:
                throw new Error(`Does not know how to instantiate ${categoryDefinitionId}`);
        }
    }

}
